/**
 * Get list of unique restriction filter (sectionCustomQuery, siteCustomQuery)
 * @param {Object} obj
 * @returns Boolean
 */
export const getRestrictionFilters = (defaultStockScope = {}) => {
  let filterNames = [];
  Object.keys(defaultStockScope).forEach((key) => {
    if (['and', 'or'].indexOf(key) > -1) {
      let childFilterObject = {};
      const childFiltersValue = defaultStockScope[key];
      if (Array.isArray(childFiltersValue)) {
        childFilterObject = childFiltersValue.reduce(
          (childResult, filter) => Object.assign(childResult, filter),
          {},
        );
      } else {
        childFilterObject = { ...childFiltersValue };
      }

      filterNames = filterNames.concat(getRestrictionFilters(childFilterObject));
      return;
    }
    filterNames = [...filterNames, key];
  });

  return filterNames.filter((item, pos) => filterNames.indexOf(item) === pos);
};

/**
 * @param {Object} obj
 * @returns Boolean
 */
export const fieldsAreEmpty = (obj = {}) => {
  if (!obj) return true;
  const getFields = Object.values(obj);
  const mappedFieldValues = getFields.map((value) => {
    if (value instanceof Object) return Object.values(value);
    return value;
  });
  const searchValues = [...mappedFieldValues].flat();

  if (searchValues.length === 0) return true;

  return searchValues.every((value) => {
    if (value === null) return true;
    if (value instanceof Object) return fieldsAreEmpty(value);
    return false;
  });
};

export default {};
